import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-225c94d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Accede para seguir este canal", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Seguir", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Siguiendo", -1))
const _hoisted_8 = [
  _hoisted_7
]

import { ref, onMounted } from 'vue'
import ChannelService from '@/services/ChannelService'
import { useAuth } from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'FollowChannelButton',
  props: ['user_id'],
  setup(__props) {

const service = new ChannelService()
const loading = ref(true)
const isFollowed = ref(false)
const store = useAuth()
const props = __props
const toast = useToast()

onMounted(async () => {
    loading.value = true
    if (!store.token) {
        loading.value = false
        return
    }
    isFollowed.value = await service.CheckIfFollows(store.token, props.user_id)
    loading.value = false
})

const DoFollow = async () => {
    loading.value = true
    if (!store.token) {
        loading.value = false
        return
    }
    await service.DoFollow(store.token, props.user_id)
    toast.showToast("Has comenzado a seguir este canal. El número de seguidores se actualizará en breve.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    isFollowed.value = true
    loading.value = false
}

const DoUnfollow = async () => {
    loading.value = true
    if (!store.token) {
        loading.value = false
        return
    }
    await service.DoUnfollow(store.token, props.user_id)
    toast.showToast("Has dejado de seguir este canal. El número de seguidores se actualizará en breve.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    isFollowed.value = false
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon",
          scale: "2"
        })
      ]))
    : (!_unref(store).token)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "animate profile-data",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'auth' })))
        }, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!isFollowed.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "animate profile-data",
                onClick: DoFollow
              }, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "animate profile-data-green",
                onClick: DoUnfollow
              }, _hoisted_8))
        ]))
}
}

})